/*
 * @Author: Dong
 * @Date: 2022-05-12 10:41:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-15 15:38:41
 */
import React from 'react';
import { Form, Divider, Input, Row, Col } from 'sup-ui';
import Modal, { CustomModalProps } from 'root/components/CommonModal';
import { WrappedFormUtils } from 'sup-ui/lib/form/Form';
import { useIntl } from 'react-intl';
import messages from './messages';
import styles from './index.less';

interface PropsType extends CustomModalProps {
  defaultData: any;
  form: WrappedFormUtils;
}

const formItemLayout = {
  labelCol: {
    span: 9,
  },
  wrapperCol: {
    span: 15,
  },
};

const SourceConfigModal = (props: PropsType) => {
  const intl = useIntl();
  const { defaultData = {}, form, ...otherProps } = props;
  const { getFieldDecorator } = form;

  const renderItem = (title: string, data = []) => {
    return (
      <div key={title}>
        <p className={styles.title}>
          <span>{title}</span>
        </p>
        {data.map((data: any, i: number) => {
          const { name, cpuAmount, cpuFormat, memAmount, memFormat, storageAmount, storageFormat, jvmOptions } = data;
          return (
            <div key={name}>
              <Form.Item style={{ display: 'none' }}>
                {getFieldDecorator(`${title}-name--${i}`, {
                  initialValue: name || '',
                })(<Input maxLength="64" />)}
              </Form.Item>
              <Row>
                <Divider orientation="left">{name}</Divider>
                <Col span={12}>
                  <Form.Item label="CPU">
                    {getFieldDecorator(`${title}-cpu-${cpuFormat || 'vC'}-${i}`, {
                      initialValue: cpuAmount || '',
                      rules: [
                        {
                          required: true,
                          message: intl.formatMessage(messages.cpuLimitRequired),
                        },
                        {
                          message: intl.formatMessage(messages.numFormat),
                          pattern: new RegExp(/^[1-9]\d*$/),
                        },
                      ],
                    })(<Input addonAfter={<span>{cpuFormat || 'vC'}</span>} maxLength="64" />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label={intl.formatMessage(messages.memory)}>
                    {getFieldDecorator(`${title}-mem-${memFormat || 'M'}-${i}`, {
                      initialValue: memAmount || '',
                      rules: [
                        {
                          required: true,
                          message: intl.formatMessage(messages.memLimitRequired),
                        },
                        {
                          message: intl.formatMessage(messages.numFormat),
                          pattern: new RegExp(/^[1-9]\d*$/),
                        },

                        {
                          validator: (rule: any, value: string, callbackFn: Function) => {
                            if (!value) return;
                            if (!memFormat && Number(value) < 4) {
                              callbackFn(intl.formatMessage(messages.memoryMin));
                            }
                            callbackFn();
                          },
                        },
                      ],
                    })(<Input addonAfter={<span>{memFormat || 'M'}</span>} maxLength="64" />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Form.Item label={intl.formatMessage(messages.tempSize)}>
                    {getFieldDecorator(`${title}-storage-${storageFormat || 'M'}-${i}`, {
                      initialValue: storageAmount || '',
                      rules: [
                        {
                          required: true,
                          message: intl.formatMessage(messages.storageLimitRequired),
                        },
                        {
                          message: intl.formatMessage(messages.numFormat),
                          pattern: new RegExp(/^[1-9]\d*$/),
                        },
                      ],
                    })(<Input addonAfter={<span>{storageFormat || 'M'}</span>} maxLength="64" />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label={intl.formatMessage(messages.java)}>
                    {getFieldDecorator(`${title}-jvmOptions--${i}`, {
                      initialValue: jvmOptions || '',
                    })(<Input maxLength="64" />)}
                  </Form.Item>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <Modal
      className={styles.modal}
      height="auto"
      width={650}
      title={intl.formatMessage(messages.sourceConfigSet)}
      {...otherProps}
    >
      <Form className={styles.form} {...formItemLayout}>
        {defaultData &&
          Object.keys(defaultData).length !== 0 &&
          Object.keys(defaultData).map((key) => {
            if (!defaultData[key] || defaultData[key].length === 0) return null;
            return renderItem(key, defaultData[key]);
          })}
      </Form>
    </Modal>
  );
};

export default Form.create()(SourceConfigModal);
